import React from "react";
import PopupBodyItem from "../../Helpers/Popup/PopupParts/PopupBodyItem";
import { formatDate } from "../../../JsHelpers/DateFormat";
import trans from "../../../utils";
import AES from "crypto-js/aes";
import CryptoJs from "crypto-js";
export default function UserInf({ values = {} }) {
	const getValue = (value, defaultValue = "-----") =>
		value ? value : defaultValue;
	const dreadonly = (value) =>
		value === true ? (
			<img src={`${process.env.PUBLIC_URL}/assets/Right.svg`} alt="on" />
		) : (
			<img src={`${process.env.PUBLIC_URL}/assets/Wrong.svg`} alt="off" />
		);
	const {
		name = "",
		email = "",
		phone = "",
		attributes: {
			speedUnit = "",
			volumeUnit = "",
			altitudeUnit = "",
			distanceUnit = "",
		} = {},
		latitude = "",
		longitude = "",
		expirationTime = "",
		deviceLimit = "",
		userLimit = "",
		deviceReadonly = "",
		readonly = "",
	} = values;
	const formattedExpirationDate = expirationTime
		? formatDate(expirationTime).formattedDate
		: "-----";

	return (
		<div>
			<p className="fs-16 fw-700 brand-700 text-uppercase">
				{trans("User Details")}
			</p>
			<div className="row">
				<div className="col-lg-6">
					<div className="display-border">
						<PopupBodyItem title={trans("Name")} item={getValue(name)} />
						<PopupBodyItem
							title={trans("phone number")}
							item={getValue(phone)}
						/>

						<PopupBodyItem
							title={trans("Latitude")}
							item={getValue(latitude)}
						/>
						<PopupBodyItem
							title={trans("Device Limit")}
							item={getValue(deviceLimit)}
						/>
						<PopupBodyItem
							title={trans("Device Read Only")}
							item={dreadonly(deviceReadonly)}
						/>
						<PopupBodyItem
							title={trans("Speed Unit")}
							item={getValue(speedUnit)}
						/>
						<PopupBodyItem
							title={trans("Altitude Unit")}
							item={getValue(altitudeUnit)}
						/>
					</div>
				</div>
				<div className="col-lg-6">
					<div className="display-border">
						<PopupBodyItem title={trans("Email")} item={getValue(email)} />{" "}
						<PopupBodyItem
							title={trans("Longitude")}
							item={getValue(longitude)}
						/>
						<PopupBodyItem
							title={trans("User Limit")}
							item={getValue(userLimit)}
						/>
						<PopupBodyItem
							title={trans("Read Only")}
							item={dreadonly(readonly)}
						/>
						<PopupBodyItem
							title={trans("Volume Unit")}
							item={getValue(volumeUnit)}
						/>
						<PopupBodyItem
							title={trans("Distance Unit")}
							item={getValue(distanceUnit)}
						/>
						<PopupBodyItem
							title={trans("Expiration Date")}
							item={getValue(formattedExpirationDate)}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}
